import React from 'react';
import { Grid, Card, CardContent, Typography, Box, LinearProgress } from '@mui/material';
import {
  DirectionsCar as VehicleIcon,
  Settings as DeviceIcon,
  Assignment as WorkIcon,
  People as ClientIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';
import { motion } from 'framer-motion';

const StatCard = ({ title, value, icon, color, trend, loading }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3 }}
  >
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography color="textSecondary" variant="caption" gutterBottom>
              {title}
            </Typography>
            {loading ? (
              <LinearProgress sx={{ width: 100, mt: 1 }} />
            ) : (
              <Typography variant="h3" fontWeight={600}>
                {value}
              </Typography>
            )}
            {trend && (
              <Box display="flex" alignItems="center" mt={1}>
                <TrendingUpIcon sx={{ fontSize: 14, color: trend > 0 ? 'success.main' : 'error.main', mr: 0.5 }} />
                <Typography variant="caption" color={trend > 0 ? 'success.main' : 'error.main'}>
                  {Math.abs(trend)}% from last month
                </Typography>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              bgcolor: `${color}.light`,
              borderRadius: '50%',
              p: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  </motion.div>
);

const StatsCards = ({ stats, loading }) => {
  const cards = [
    { title: 'Total Vehicles', value: stats?.totalVehicles || 0, icon: <VehicleIcon sx={{ color: '#1976d2' }} />, color: 'primary', trend: 12 },
    { title: 'Active Devices', value: stats?.activeDevices || 0, icon: <DeviceIcon sx={{ color: '#4caf50' }} />, color: 'success', trend: 8 },
    { title: 'Work Orders', value: stats?.workOrders?.total || 0, icon: <WorkIcon sx={{ color: '#ff9800' }} />, color: 'warning', trend: -5 },
    { title: 'Total Clients', value: stats?.clients?.total || 0, icon: <ClientIcon sx={{ color: '#9c27b0' }} />, color: 'secondary', trend: 0 },
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <StatCard {...card} loading={loading} />
        </Grid>
      ))}
    </Grid>
  );
};

export default StatsCards;